module.exports = __webpack_public_path__ + "img/ejemplo_importacion_albaranes_csv.dc7432d9.png";